import { cn } from '@/lib/utils'

interface ImportanceBadgeProps {
  score: number
  className?: string
}

export function ImportanceBadge({ score, className }: ImportanceBadgeProps) {
  const tier =
    score >= 7 ? 'high' :
    score >= 4 ? 'mid' :
    'low'

  const styles = {
    high: 'bg-green-50 border-green-300/50 text-green-700',
    mid: 'bg-amber-50 border-amber-300/50 text-amber-700',
    low: 'bg-soft-panel border-border-gray text-muted-foreground',
  }

  return (
    <span
      data-testid="importance-badge"
      data-score={score}
      data-tier={tier}
      className={cn(
        'inline-flex items-center gap-0.5 text-xs font-medium rounded-full border px-2 py-0.5',
        styles[tier],
        className
      )}
    >
      {score}/10
    </span>
  )
}
